<template>
  <div class="orm-container-fluid orm-reservationInfobar">
    <div class="orm-container">
      <div class="orm-row center-xl left-lg">
        <div class="orm-col-xs-12 orm-col-md-12 orm-col-lg-12 orm-padding20">
          <div class="orm-row">
            <Stationpicker
              v-if="stations"
              class="orm-col-xs-12 orm-col-sm-12 orm-col-md-5 orm-col-lg-4"
              :data="stations"
              :readonly="true"
              type="start"
            />
            <div
              class="orm-relative orm-col-xs-12 orm-col-sm-6 orm-col-md-4 orm-col-lg-3"
            >
              <Datepicker :infobar="true" viewType="infobar" />
            </div>
            <div
              class="orm-relative orm-col-xs-12 orm-col-sm-6 orm-col-md-3 orm-col-lg-5"
            >
              <div class="orm-minabo_container">
                <span class="orm-minabo_title"
                  >{{
                    i18n("search/label/minabo_title_selected") || "Abo-Länge"
                  }}:
                </span>
                <SimpleSelect
                  :my-options="abolength"
                  :selected="selectedAbo"
                  @selected="selectAbo"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { defineComponent } from "vue";
import store from "@/store";
import Datepicker from "@/components/ui/datepicker-startonly.vue"; // @ is an alias to /src
import Stationpicker from "@/components/ui/stationpicker-plz.vue"; // @ is an alias to /src
import SimpleSelect from "@/components/ui/INPUTS/SimpleSelect.vue"; // @ is an alias to /src

import i18n from "@/mixins/mixins";

export default defineComponent({
  name: "infobar_step3_plz",
  components: { Stationpicker, Datepicker, SimpleSelect },
  setup() {
    let stations = store.getters["stations/GET_STATIONS"];
    const filtered = store.getters["stations/GET_STATIONS_FILTERED"];
    const type = document.getElementById("crentReservation").dataset
      .stationtype;

    if (type) {
      stations = filtered[type];
    }
    return {
      stations,
      store,
    };
  },
  mixins: [i18n],
  data() {
    return {
      stationSelected: store.getters["userSession/GET_STATION"],
      stationSelectedEnd: store.getters["userSession/GET_STATION_END"],
      abolength: null,
      selectedAbo: null,
    };
  },
  async mounted() {
    this.abolength = await store.getters["reservation/GET_ABO_LENGTH"];
    this.selectedAbo = await store.getters["reservation/GET_SELECTEDABO"];
  },
  props: {
    data: Object,
    type: String,
    step: Number,
  },
  methods: {
    selectAbo(abo) {
      console.log(abo);
      store.dispatch("reservation/SET_ABOLENGTH", abo);
      store.dispatch("stations/SET_OPENINGTIMES");
    },
  },
});
</script>
